import React, { useState } from 'react';
import { HomePage } from './pages/HomePage';
import { ShippingForm } from './components/ShippingForm';
import { PaymentPage } from './components/PaymentPage';
import { PaymentSuccessPage } from './components/PaymentSuccessPage';
import { TrackingPage } from './components/TrackingPage';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { UsaToLagosPage } from './pages/UsaToLagosPage';
import { InterstateDeliveryPage } from './pages/InterstateDeliveryPage';
import { ExpressShippingPage } from './pages/ExpressShippingPage';
import { CargoFreightPage } from './pages/CargoFreightPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'shipping' | 'payment' | 'payment-success' | 'tracking' | 'about' | 'contact' | 'usa-to-lagos' | 'interstate-delivery' | 'express-shipping' | 'cargo-freight'>('home');
  const [orderData, setOrderData] = useState({
    total: 127.5,
    packageCount: 1,
    route: 'New York, USA → Lagos, Nigeria',
    packageType: 'Electronics'
  });
  const handleNavigate = (page: string) => {
    if (page === 'shipping') {
      setCurrentPage('shipping');
    } else if (page === 'payment') {
      setCurrentPage('payment');
    } else if (page === 'payment-success') {
      setCurrentPage('payment-success');
    } else if (page === 'tracking' || page === 'track') {
      setCurrentPage('tracking');
    } else if (page === 'about') {
      setCurrentPage('about');
    } else if (page === 'contact') {
      setCurrentPage('contact');
    } else if (page === 'usa-to-lagos') {
      setCurrentPage('usa-to-lagos');
    } else if (page === 'interstate-delivery') {
      setCurrentPage('interstate-delivery');
    } else if (page === 'express-shipping') {
      setCurrentPage('express-shipping');
    } else if (page === 'cargo-freight') {
      setCurrentPage('cargo-freight');
    } else {
      setCurrentPage('home');
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleProceedToPayment = (data: {
    total: number;
    packageCount: number;
    route: string;
    packageType: string;
  }) => {
    setOrderData(data);
    setCurrentPage('payment');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handlePaymentComplete = () => {
    setCurrentPage('payment-success');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-0">
      <SiteHeader currentPage={currentPage} onNavigate={handleNavigate} data-id="element-1" />

      <main className="flex-1" data-id="element-2">
        {currentPage === 'home' && <HomePage onNavigate={handleNavigate} data-id="element-3" />}
        {currentPage === 'shipping' && <ShippingForm onProceedToPayment={handleProceedToPayment} data-id="element-4" />}
        {currentPage === 'payment' && <PaymentPage orderSummary={orderData} onBack={() => handleNavigate('shipping')} onComplete={handlePaymentComplete} data-id="element-5" />}
        {currentPage === 'payment-success' && <PaymentSuccessPage orderSummary={orderData} onTrackShipment={() => handleNavigate('tracking')} onShipAnother={() => handleNavigate('shipping')} onGoHome={() => handleNavigate('home')} data-id="element-6" />}
        {currentPage === 'tracking' && <TrackingPage onBack={() => handleNavigate('home')} data-id="element-7" />}
        {currentPage === 'about' && <AboutPage onNavigate={handleNavigate} data-id="element-8" />}
        {currentPage === 'contact' && <ContactPage onNavigate={handleNavigate} data-id="element-9" />}
        {currentPage === 'usa-to-lagos' && <UsaToLagosPage onNavigate={handleNavigate} data-id="element-10" />}
        {currentPage === 'interstate-delivery' && <InterstateDeliveryPage onNavigate={handleNavigate} data-id="element-11" />}
        {currentPage === 'express-shipping' && <ExpressShippingPage onNavigate={handleNavigate} data-id="element-12" />}
        {currentPage === 'cargo-freight' && <CargoFreightPage onNavigate={handleNavigate} data-id="element-13" />}
      </main>

      <SiteFooter onNavigate={handleNavigate} data-id="element-14" />
    </div>;
}